exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-019f8792] {\n  margin-top: 70px;\n}", ""]);

// exports
